import { cn } from "design-system/utils"
import { formatCompanyClient } from "modules/customers/lib/formatCompanyClient"
import { CompanyClientResponseDataSchema } from "schema"
import { z } from "zod"

type Props = {
  client: z.infer<typeof CompanyClientResponseDataSchema> | null | undefined
  className?: string
}

export function CompanyClientCell({ client, className }: Props) {
  const label = formatCompanyClient(client)

  return <span className={cn(!label && "text-muted-foreground", className)}>{label ?? "-"}</span>
}
